import { X } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import PlaidLinkRetry from '../../../../../../components/signup/customers/PlaidLinkRetry';
import { Application } from '../../../../../../types/dbTypes';
import { ApplicationStep, Entity } from '../../../../../../types/apiTypes';
import { useOptimisticApplicationStep } from '../../../../../../hooks/useOptimisticApplicationStep';

interface PlaidLinkRetryModalProps {
  isOpen: boolean;
  onClose: () => void;
  application_id: string;
  application: Application;
  userId: string;
}

function PlaidLinkRetryModal({
  isOpen,
  onClose,
  application_id,
  application,
  userId,
}: PlaidLinkRetryModalProps) {
  const navigate = useNavigate();
  const optimisticSetApplicationStep = useOptimisticApplicationStep(userId);

  if (!isOpen) return null;

  const handleClose = () => {
    onClose();
    navigate('/dashboard/home');
  };

  const handleSetStep = (step: string) => {
    // When step changes, close the modal and refresh
    if (step !== ApplicationStep.PlaidLinkRetry) {
      // Optimistically reflect the new step so the dashboard updates immediately instead of
      // flashing the stale card while onClose()'s background refetch is in flight.
      optimisticSetApplicationStep(step);
      onClose();
      navigate('/dashboard/home');
    }
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="relative h-full w-full bg-white">
        {/* Close Button */}
        <button
          onClick={handleClose}
          className="absolute right-6 top-6 z-[210] flex h-10 w-10 items-center justify-center rounded-full bg-white text-gray-600 shadow-lg transition-all hover:bg-gray-100 hover:text-gray-900"
          aria-label="Close and return to dashboard"
        >
          <X size={24} weight="bold" />
        </button>

        {/* Plaid Link Retry Component */}
        <div className="h-full w-full overflow-y-auto">
          <PlaidLinkRetry
            currStep={ApplicationStep.PlaidLinkRetry}
            selectedRole={Entity.Customer}
            setStep={handleSetStep}
            application_id={application_id}
            application={application}
          />
        </div>
      </div>
    </div>
  );
}

export default PlaidLinkRetryModal;
